import $ from 'jquery';
import scrollTo from '../util/scrollTo';

const highlightActiveTab = (tabs, $container, eventType = 'scroll', offset = 0) => {

  const lastTab = tabs.get(tabs.length - 1);
  const container = $container.get(0);

  for (let i = 0; i < tabs.length; i++) {
    let tab = tabs.get(i);
    const top = document.getElementById(tab.getAttribute('data-tab')).offsetTop;
    let bottom = false;
    if (i < tabs.length - 1) {
      const nextTab = tabs.get(i+1);
      bottom = document.getElementById(nextTab.getAttribute('data-tab')).offsetTop;
    }

    const scrollTop = container.scrollTop + offset;
    const scrollMax = container.scrollHeight - container.clientHeight;


    if( top <= scrollTop && (!bottom || bottom > scrollTop) ){
      if (scrollTop < scrollMax || eventType !== 'resize' &&  scrollTop >= scrollMax) {
        tabs.removeClass('tabs__tab--active');
     }

      if (eventType === 'scroll' && scrollTop >= scrollMax) {
        tab = lastTab;
      }

      if (eventType !== 'resize' || scrollMax > 0) {
        tab.className = tab.className += ' tabs__tab--active';
      }

      break;
    }
  }
};

export default function tabs() {
  const $tabs = $('[data-tab]');
  const $container = $('[data-tab-scroll-container]');

  $tabs.on('click', function(e) {
    e.preventDefault();
    $tabs.removeClass('tabs__tab--active');
    this.className = this.className += ' tabs__tab--active';
    scrollTo.element(document.getElementById($(this).data('tab')), 500, 20, () => {
      $tabs.removeClass('tabs__tab--active');
      this.className = this.className += ' tabs__tab--active';
    }, $container.get(0));
  });


  $container.on('scroll', () => highlightActiveTab($tabs, $container, 'scroll', 20));
  window.addEventListener('resize', () =>highlightActiveTab($tabs, $container, 'resize', 20));
}


// WEBPACK FOOTER //
// ./scripts/lib/tabs.js